// extracted by mini-css-extract-plugin
module.exports = {"root":"ToolsPagination_root__e8yy3","_button":"ToolsPagination__button__IjGm_"};